import React from "react";
import styled, { keyframes } from "styled-components";
import { FullPageCenteredContent } from "./FullPageCenteredContent";
import { FullWidth } from "./FullWidth";
import { TractieIconProps } from "@tractie/components/custom-elements";

interface LoadingStateProps {
  readonly message?: string;
  readonly fullPage?: boolean;
}

export function LoadingState({
  message = "Informatie wordt opgehaald",
  fullPage = true,
}: LoadingStateProps): React.JSX.Element {
  if (!fullPage) {
    return (
      <FullWidth>
        <TractieSpinningIcon name="loader" color="--tractie-color-content-emphasis" />
        <div>{message}</div>
      </FullWidth>
    );
  }
  return (
    <FullPageCenteredContent>
      <TractieSpinningIcon name="loader" color="--tractie-color-content-emphasis" />
      <div>{message}</div>
    </FullPageCenteredContent>
  );
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const TractieSpinningIcon = styled("tractie-icon")<TractieIconProps>`
  animation: ${rotate} 1s linear infinite;
`;
